import type { AppDispatch, RootState } from '@/store/store'
import { getRootFolder } from '@/user_files/folders/fetch/get-root-folder'
import { UserFoldersActions } from '@/user_files/folders/store/slice'
import { selectRootFolderIdForMatter } from '@/user_files/folders/store/selectors'

const inFlightRootFolderRequests = new Map<string, Promise<string>>()

/**
 * The matter's root folder id, from the store when it is already there and from the server when it
 * is not. Rejects when the folder cannot be read, so a caller that needs somewhere to put a file
 * fails visibly rather than doing nothing.
 *
 * Concurrent callers for one matter share a single request.
 */
export function getOrFetchRootFolderId(params: { dispatch: AppDispatch; getState: () => RootState; matterId: string }): Promise<string> {
  const existingRootFolderId = selectRootFolderIdForMatter(params.getState(), { matterId: params.matterId })
  if (existingRootFolderId) return Promise.resolve(existingRootFolderId)

  const existingInFlightRequest = inFlightRootFolderRequests.get(params.matterId)
  if (existingInFlightRequest) return existingInFlightRequest

  const promise = getRootFolder(params.matterId)
    .then((response) => {
      params.dispatch(UserFoldersActions.upsertFolder(response.folder))
      return response.folder.id
    })
    .finally(() => {
      inFlightRootFolderRequests.delete(params.matterId)
    })
  inFlightRootFolderRequests.set(params.matterId, promise)
  return promise
}
